import type TomSelect from "tom-select";
import {
    deselectAllItemsEndedEventName,
    deselectAllItemsStartedEventName,
} from "./SelectedAutoItemsTomSelectPlugin";

export function deselectAllButtonTomSelectPlugin(this: TomSelect, options: { [textContent: string]: string }): void {
    this.on("initialize", () => {
        let buttonsWrapper = this.dropdown.querySelector(".tomselect-dropdown-buttons-wrapper");
        const dropdownInputWrap = this.dropdown.querySelector(".dropdown-input-wrap");

        const deselectAllButton = document.createElement("button");
        deselectAllButton.className = "actions-btn btn btn-light";
        deselectAllButton.type = "button";
        deselectAllButton.textContent = options?.textContent || "Deselect All";

        const startDeselectAllEvent: CustomEvent = new CustomEvent(deselectAllItemsStartedEventName);
        const endDeselectAllEvent: CustomEvent = new CustomEvent(deselectAllItemsEndedEventName);
        deselectAllButton.addEventListener("click", (e) => {
            this.control.dispatchEvent(startDeselectAllEvent);
            const allOptions: Element[] = Array.from(this.dropdown.querySelectorAll("[role=\"option\"]")).reverse();
            allOptions.forEach((option: Element): void => {
                const htmlOption = option as HTMLElement;
                if (this.items.includes(htmlOption.dataset.value ?? "")) {
                    this.removeItem(htmlOption.dataset.value ?? "");
                }
            });
            this.control.dispatchEvent(endDeselectAllEvent);
        });

        if (!buttonsWrapper) {
            buttonsWrapper = document.createElement("div");
            buttonsWrapper.className = "tomselect-dropdown-buttons-wrapper";
            buttonsWrapper.appendChild(deselectAllButton);

            if (dropdownInputWrap) {
                dropdownInputWrap.insertAdjacentElement("afterend", buttonsWrapper);
            } else {
                this.dropdown.insertBefore(buttonsWrapper, this.dropdown.firstChild);
            }
        } else {
            buttonsWrapper.appendChild(deselectAllButton);
        }
    });
}
